export const GET_COMMENT_BY_PATH = "getCommentByPath";
export const IS_SHOWN_COMMENT_ROOT_COMMENT = "isShownCommentRootComment";
